import * as types from "../actions/actionType";

const defaultState = {
	isLoading: false,
	showPayModal: false,
	showPayVeil: false,
	disablePayModal: true,
	accountPaid: false,
	isLoadingWithError: false,
}
const checkState =  (state) => {
	if(state===null || state===undefined || Object.keys(state).length===0){
		state=defaultState;
	}
	return state;
}

const uiReducer = (state, action) => {
	state=checkState(state);
	switch (action.type) {
		case types.SHOW_PAYMODAL:
			return {
				...state,
				showPayModal: true,
				disablePayModal: false
			};
		case types.HIDE_PAYMODAL:
			return {
				...state,
				showPayModal: false
			};
        case types.PAID_ACCCOUNT:

            return {
                ...state,
				accountPaid:true
            };
		case types.DISABLE_PAYMODAL:
			return {
				...state,
				disablePayModal: true
			};
		case types.ENABLE_LOADER:
			return {
				...state,
				isLoading: true
			};
		case types.DISABLE_LOADER:
			return {
				...state,
				isLoading: false
			};
		case types.DISABLE_LOADER_WITH_ERROR:
			return {
				...state,
				isLoading: false,
				isLoadingWithError: true
			}
        case types.SHOW_PAYVEIL:
            return {
                ...state,
                showPayVeil: true
            };
        case types.HIDE_PAYVEIL:
            return {
                ...state,
                showPayVeil: false
            };
        default:
			return state;
	}
}

export default uiReducer;



// WEBPACK FOOTER //
// ./src/reducers/uiReducer.js